import { render, staticRenderFns } from "./RuleEdit.vue?vue&type=template&id=1f5c7188&scoped=true"
import script from "./RuleEdit.vue?vue&type=script&lang=js"
export * from "./RuleEdit.vue?vue&type=script&lang=js"
import style0 from "./RuleEdit.vue?vue&type=style&index=0&id=1f5c7188&prod&lang=css"
import style1 from "./RuleEdit.vue?vue&type=style&index=1&id=1f5c7188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5c7188",
  null
  
)

export default component.exports